import { createHashHistory } from "history";

// configure, create, and export the project's history instance
export default createHashHistory();
